export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST';

export const deleteFileRequest = ( guid ) => ({
    type: DELETE_FILE_REQUEST,
    payload: { guid }
});
